/**
 * exportAnalyticsReportPdf.js
 *
 * Stage 10 — orchestrates Model → Render → Print for one Saved Report.
 * Same window.open() timing as exportCostControlPdf.js (synchronous,
 * before any await, so the browser never treats it as a blocked popup).
 *
 * Critically: `result` here is REQUIRED to be the same object the
 * caller already has from the Live Preview/Viewer — this function does
 * NOT re-execute the query itself. This guarantees the printed numbers
 * always match what was on screen when the person chose to print,
 * exactly as CostControl's PDF export re-uses the screen's own
 * monthlyActualCost object rather than re-fetching it.
 */

import { buildAnalyticsReportPdfModel } from './buildAnalyticsReportPdfModel'
import { renderAnalyticsReportPdf } from './AnalyticsReportPdfRenderer'

/**
 * @param {SavedReport} report
 * @param {QueryResult|TimeSeriesResult} result - already-executed,
 *   caller-supplied (never fetched here)
 * @param {object} [options]
 */
export function exportAnalyticsReportPdf(report, result, options = {}) {
  const win = window.open('', '_blank')

  const model = buildAnalyticsReportPdfModel(report, result, options)
  const html = renderAnalyticsReportPdf(model)

  win.document.write(html)
  win.document.close()
  win.focus()
  setTimeout(() => win.print(), 300)
}
